import React, { Suspense } from 'react'
import { Redirect, Route, Router } from 'react-router-dom'
import history from './History'
import X46Container from './X46/X46Container'
import X46MK2Container from './X46MK2/X46MK2Container'
import X49Container from './X49/X49Container'
import X49MK2Container from './X49MK2/X49MK2-Container'
import X43Container from './X43/X43Container'
import X43MK2Container from './X43MK2/X43MK2Container'
import X40Container from './X40/X40Container'
import X56Container from './X56/X56Container'
import XP44Container from './XP44/XP44Container'
import XP55Container from './XP55/XP55Container'
import XC45Container from './XC45/XC45Container'
import XC38Container from './XC38/XC38Container'
import XPowerContainer from './Xpower/XPowerContainer'
import Xc47Container from './Xc47/Xc47Container'
import Xr41Container from './Xr41/Xr41Container'
import ReactGA from 'react-ga'

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href')

class App extends React.Component {
  componentDidMount () {
    history.listen(url => {
      ReactGA.pageview(url.pathname)
    })
  }

  render () {
    return (
      <Router basename={baseUrl} history={history}>
        <div>
          <Route exact path='/' render={() => <Redirect to='/x49mk2' />} />
          <Route path='/x49mk2' component={X49MK2Container} />
          <Route path='/x49' component={X49Container} />
          <Route path='/x46' component={X46Container} />
          <Route path='/x46mk2' component={X46MK2Container} />
          <Route path='/x43mk2' component={X43MK2Container} />
          <Route path='/x43' component={X43Container} />
          <Route path='/x40' component={X40Container} />
          <Route path='/x56' component={X56Container} />
          <Route path='/xp44' component={XP44Container} />
          <Route path='/xp55___' component={XP55Container} />
          <Route path='/xc38___' component={XC38Container} />
          <Route path='/xc45' component={XC45Container} />
          <Route path='/xpower' component={XPowerContainer} />
          <Route path='/xc47' component={Xc47Container} />
          <Route path='/xr41' component={Xr41Container} />
        </div>
      </Router>
    )
  }
}

// loading component for suspense fallback
const Loader = () => (
  <div className='App'>
    <div>loading...</div>
  </div>
)

export default function AppLoader () {
  return (
    <Suspense fallback={<Loader />}>
      <App />
    </Suspense>
  )
}



// WEBPACK FOOTER //
// ./src/App.js